import React, { useRef, useState } from "react";
import PopUpScreen from "../../component/popUpScreen/popUpScreen";
import { Formik, Form, Field } from "formik";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import * as Yup from "yup";
import { LabelWrapper } from "../../component/inputtext/inputtextStyle";
import { FieldLabel } from "../global/global.style";
import FormDropdown from "../../component/dropdown/formDropdown";

import { Message } from "primereact/message";
import { useQuery } from "@tanstack/react-query";
import accessManagementService from "../../services/accessManagementService";

import { CreateUserMutation } from "../../mutations/AccessManagementMutationHook";
import { useToast } from "../../context/ToastContext";
import AppQueries, { GetDomainAndSubdomains, getDomainAndSubdomains } from "../../queries/appQueries";
function AddNewMember({ onHide }) {
  const addMemeberValidationSchema = Yup.object({
    username: Yup.string().required("Username is required"),
    email: Yup.string()
      .required("Email is required")
      .email("Invalid email address"),
    domain: Yup.object().required("Domain is Required"),
    subDomain: Yup.object().required("Sub Domain is Required"),
    cluster: Yup.object().required("Cluster is Required"),
    market: Yup.object().required("Market is Required"),
    role: Yup.object().required("Access is Required"),
  });

  const closeDialog = () => {
    onHide();
  };



  const {
    data: domainAndSubdomains = [],
    isLoading: isDomainAndSubdomainsLoading,
  } = GetDomainAndSubdomains()

  const { data: countryAndRegion = [], isLoading: isCountryAndRegionsLoading } =
    useQuery({
      queryKey: ["getCountryAndRegion"],
      queryFn: () => accessManagementService.getCountryAndRegion(),
    });

  const { data: allRoles = [], isLoading: isAllRolesDataLoading } = useQuery({
    queryKey: ["getAllUserRoles"],
    queryFn: () => accessManagementService.getAllRoles(),
  });

  const toast = useToast();

  const { mutate: createUser, isPending: isUserCreating } = CreateUserMutation(
    () => {
      toast({
        severity: "info",
        summary: "Confirmed",
        detail: `User Created Successfullly`,
        life: 3000,
      });

      onHide();
    },
    (error) => {
      toast({
        severity: "info",
        summary: "Error",
        detail: error?.response?.data?.detail || error.message,
        life: 3000,
      });
    }
  );

  return (
    <PopUpScreen
      header="Add Member"
      onHide={closeDialog}
      style={{ width: "40%" }}
    >
      <Formik
        initialValues={{
          username: "",
          email: "",
          domain: "",
          subDomain: "",
          cluster: "",
          market: "",
          role: "",
        }}
        validationSchema={addMemeberValidationSchema} // Attach Yup validation schema
        onSubmit={(values, { setSubmitting }) => {
          createUser({
            user_name: values.username,
            user_email: values.email,
            domain: values.domain.domain_name,
            sub_domain: values.subDomain.sub_domain_name,
            region: values.cluster.region,
            country: values.market.country,
            role_id: values.role.role_id,
            created_by: localStorage.getItem("userId"),
            is_active: true,
          });

          console.log("Form Values:", values);
          setSubmitting(false);
        }}
      >
        {({
          dirty,
          isValid,
          errors,
          touched,
          isSubmitting,
          setFieldValue,
          values,
          handleChange,
          handleBlur,
        }) => (
          <Form>
            <div className="grid">
              <div className="col-12">
                <LabelWrapper>
                  <FieldLabel>Username</FieldLabel>
                </LabelWrapper>

                <InputText
                  placeholder="Enter  Username"
                  id="username"
                  name="username"
                  value={values.username}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  style={{ width: "100%" }}
                />

                {errors["username"] && touched.username && (
                  <Message
                    className="my-2 w-full"
                    severity="warn"
                    text={errors["username"]}
                  />
                )}
              </div>

              <div className="col-12">
                <LabelWrapper>
                  <FieldLabel>Email</FieldLabel>
                </LabelWrapper>
                <InputText
                  placeholder="Enter your Email"
                  id="email"
                  name="email"
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  style={{ width: "100%" }}
                />
                {touched.email && errors.email && (
                  <Message
                    className="my-2 w-full"
                    severity="warn"
                    text={errors["email"]}
                  />
                )}
              </div>

              <div className="col-12">
                <FormDropdown
                  loading={isDomainAndSubdomainsLoading}
                  name="domain"
                  value={values.domain}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  style={{ width: "100%", marginBottom: "5px" }}
                  options={domainAndSubdomains?.data}
                  placeholder="Choose the Domain"
                  optionLabel="domain_name"
                  label="Domain"
                  required={true}
                />
                {touched.domain && errors.domain && (
                  <Message
                    className="my-2 w-full"
                    severity="warn"
                    text={errors["domain"]}
                  />
                )}
              </div>
              <div className="col-12">
                <FormDropdown
                  disabled={!values?.domain?.subdomains}
                  loading={isDomainAndSubdomainsLoading}
                  style={{ width: "100%", marginBottom: "5px" }}
                  options={values?.domain?.subdomains}
                  placeholder="Choose the Sub Domain"
                  optionLabel="sub_domain_name"
                  label="Sub Domain"
                  name="subDomain"
                  value={values.subDomain}
                  required={true}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                {touched.subDomain && errors.subDomain && (
                  <Message
                    className="my-2 w-full"
                    severity="warn"
                    text={errors["subDomain"]}
                  />
                )}
              </div>

              <div className="col-12">
                <FormDropdown
                  loading={isCountryAndRegionsLoading}
                  style={{ width: "100%", marginBottom: "5px" }}
                  options={countryAndRegion?.data?.filter(
                    (obj, index, self) =>
                      index ===
                      self.findIndex((item) => item.region === obj.region)
                  )}
                  placeholder="Select Cluster"
                  optionLabel="region"
                  label="Cluster"
                  name="cluster"
                  value={values.cluster}
                  required={true}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                {touched.cluster && errors.cluster && (
                  <Message
                    className="my-2 w-full"
                    severity="warn"
                    text={errors["cluster"]}
                  />
                )}
              </div>

              <div className="col-12">
                <FormDropdown
                  disabled={!values?.cluster}
                  style={{ width: "100%", marginBottom: "5px" }}
                  options={countryAndRegion?.data?.filter(
                    (obj, index, self) =>
                      index ===
                      self.findIndex((item) => item.country === obj.country)
                  )}
                  placeholder="Select Market"
                  optionLabel="country"
                  label="Market"
                  name="market"
                  value={values.market}
                  required={true}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                {touched.market && errors.market && (
                  <Message
                    className="my-2 w-full"
                    severity="warn"
                    text={errors["market"]}
                  />
                )}
              </div>

              <div className="col-12">
                <FormDropdown
                  loading={isAllRolesDataLoading}
                  style={{ width: "100%", marginBottom: "5px" }}
                  options={allRoles}
                  placeholder="Choose the Access"
                  optionLabel="role_name"
                  label="Access"
                  name="role"
                  value={values.role}
                  required={true}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                {touched.role && errors.role && (
                  <Message
                    className="my-2 w-full"
                    severity="warn"
                    text={errors["role"]}
                  />
                )}
              </div>
            </div>

            <div className="flex  gap-2 justify-content-end">
              <Button
                outlined
                label="Close"
                onClick={onHide}
                disabled={isSubmitting}
              />
              <Button
                loading={isUserCreating}
                type="submit"
                label="Submit"
                disabled={isSubmitting || !dirty || !isValid || isUserCreating}
              />
            </div>
          </Form>
        )}
      </Formik>
    </PopUpScreen>
  );
}

export default AddNewMember;
